import React,{useState} from 'react'
import LoginForm from './components/LoginForm';
import Home from './components/Home';
import AHome  from './components/AHome';
import  Hpassword from './components/Hpassword';
import {BrowserRouter as Router,Switch,Route} from 'react-router-dom';
import {Protegerotas} from './components/protegerotas';
import RHome from './components/RHome';
import CHome from './components/CHome';
function App() {
  return (
    <Router>
      <div className="App">
        <Switch>
          <Route path="/" exact component={LoginForm}/>
          <Protegerotas path="/home"   component={Home}/>
          <Protegerotas path="/admin/home"  component={AHome}/>
          <Protegerotas path="/password-reset" component={Hpassword}/>
          <Protegerotas path="/cont/home" component={CHome}/>
          <Protegerotas path="/test/home" component={RHome}/>
          <Route path="*" component={()=>"404"}/>
        </Switch>
      </div>
    </Router>
    
  );
}

export default App;
